import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {IReferencePathNodeObjectModelProperty, IReferencePathNodeSpecific, IReferencePathReferenceDetails, IReferencePathReferenceDetailsPickList, ReferencePathReferenceDetailsType} from "~/interfaces/referencePathInterfaces"
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import {IOrganization} from '~/interfaces/organizationInterfaces'
import {NumberType} from '~/enums/numberType'

export class ObjectModelPropertyPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.ObjectModelProperty

  constructor(private objectModelPropertyNode: IReferencePathNodeObjectModelProperty) {
    super();
  }

  get label(): string {
    return this.objectModelPropertyNode.reference()?.defaultLabelTitle;
  }

  get nodes(): IReferencePathNodeObjectModelProperty[] {
    return [this.objectModelPropertyNode];
  }

  reference(): ObjectModelProperty {
    return ObjectModelProperty.repo.findById(this.objectModelPropertyNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('ObjectModelPropertyPathService', this.objectModelPropertyNode, node, decision)
    return decision;
  }

  get referenceIsCollection(): boolean {
    return this.reference()?.isDataCollection
  }

  get referenceIsAppendable(): boolean {
    // check for never appendables
    if (this.referenceIsPickList() || this.referenceIsNumber()) return false;
    // check for appendables
    return this.reference().isDataCollection || this.referenceIsText();
  }

  get referenceIsSelectable(): boolean {
    return this.reference().isDataCollection && this.referenceIsPickList();
  }

  get referenceDetails(): IReferencePathReferenceDetails {
    const ref = this.reference()
    if (this.referenceGenericModelType === ModelType.DateTime) {
      return {
        type: ReferencePathReferenceDetailsType.DateTimePicker,
        mode: ref.datetime_mode,
        min: ref.min_datetime,
        max: ref.max_datetime,
      }
    } else if (this.referenceIsPickList()) {
      return {
        type: ReferencePathReferenceDetailsType.PickList,
        selectionType: ref.selection_type,
        options: ref.objectModelPropertyHandler.map(p => {
          return { label: p.defaultLabelTitle, value: p.client_id }
        }),
      }
    } else if (this.referenceIsNumber()) {
      return {
        type: ReferencePathReferenceDetailsType.Number,
        numType: NumberType.float,
        min: null,
        max: null,
      }
    } else {
      return {
        type: ReferencePathReferenceDetailsType.Text,
      }
    }
  }

  referenceIsPickList(): this is { referenceDetails: IReferencePathReferenceDetailsPickList } {
    return this.reference()?.isPickList
  }

  toUniversalValue(value: any, ...args: any[]) {
    return this.reference()?.toUniversalValue(value, ...args)
  }

  fromUniversalValue(value: any) {
    return this.reference()?.fromUniversalValue(value)
  }

  get organization(): IOrganization {
    return this.reference()?.organization
  }
}